import * as React from "react";
import { useCallback, useImperativeHandle, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import MenuItem from "components/bootstrap/menuitem/MenuItem";
import SetOwnerBulk from "security-app/components/SecurityEvents/Alerts/AlertsModals/UsersModal/SetOwnerBulk";
export const BulkSetOwnerModal = React.forwardRef(({ events }, ref) => {
  const [showModal, setShowModal] = useState(false);
  const eventIds = useMemo(() => events.map((event) => event.id), [events]);
  const onClose = useCallback(() => setShowModal(false), []);
  useImperativeHandle(ref, () => ({
    toggle: () => setShowModal(true)
  }));
  return /* @__PURE__ */ React.createElement(SetOwnerBulk, { eventIds, onClose, show: showModal });
});
export const BulkSetOwnerAction = ({ modalRef, onEventCallback }) => {
  const { t } = useTranslation("enterprise_security_events");
  const onClick = useCallback(() => {
    if (typeof onEventCallback === "function") {
      onEventCallback();
    }
    return modalRef().toggle();
  }, [modalRef, onEventCallback]);
  return /* @__PURE__ */ React.createElement(MenuItem, { onClick }, t("bulk_set_owner_action.label"));
};
